interface Props {
  size?: number;
  color?: string;
}

const CopyToClipboardIcon = (props: Props) => {
  const { color = '#1C274C', size = 30 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 13.75C7.5 10.2145 7.5 8.4467 8.59835 7.34835C9.6967 6.25 11.4645 6.25 15 6.25H18.75C22.2855 6.25 24.0532 6.25 25.1516 7.34835C26.25 8.4467 26.25 10.2145 26.25 13.75V20C26.25 23.5355 26.25 25.3032 25.1516 26.4016C24.0532 27.5 22.2855 27.5 18.75 27.5H15C11.4645 27.5 9.6967 27.5 8.59835 26.4016C7.5 25.3032 7.5 23.5355 7.5 20V13.75Z"
        stroke={color}
        strokeWidth="1.875"
      />
      <path
        d="M7.5 23.75C5.42894 23.75 3.75 22.0711 3.75 20V12.5C3.75 7.78595 3.75 5.42894 5.21446 3.96446C6.67894 2.5 9.03595 2.5 13.75 2.5H18.75C20.8211 2.5 22.5 4.17894 22.5 6.25"
        stroke={color}
        strokeWidth="1.875"
      />
    </svg>
  );
};

export default CopyToClipboardIcon;
